import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import TStore from 'types/store';
import Modal from '../modal';

const ModalDesktop: React.FC = () => {
  const isLogged: boolean = useSelector((store: TStore) => store.auth.isLogged);
  const isSmall = useMediaQuery({ query: '(max-width: 1023px)' });

  //added for registration on mobile
  if (isSmall && isLogged) {
    return (
      <Modal isOpen={true} zIndex={999999}>
        <h4>
          <FormattedMessage id="app.desktop_only" />
        </h4>
      </Modal>
    );
  }

  return null;
};

export default ModalDesktop;
